module.exports = __webpack_public_path__ + "static/media/frutos-rojos.e4460b22.webp";